import io from 'socket.io-client'

let socket = null
let domain = null
let port = null
let namespace = null

class AnnouncementSocket {
  constructor () {}

  setSocket (object) {
    socket = object
  }

  setNode (object) {
    domain = object.announcements.domain
    port = object.announcements.port
    namespace = object.announcements.pivot.namespace

    // Check if null, to avoid resetting the node.
    if (socket === null) {
      this.setSocket(io.connect(`${domain}:${port}/${namespace}`, { transports: ['websocket'] }))
    }
  }

  getSocket () {
    return socket
  }
}

export default (new AnnouncementSocket)
